import * as Yup from "yup";

export const getVendorValidationSchema = (isEditMode = false) => {
  return Yup.object().shape({
    first_name: Yup.string()
      .trim()
      .required("First name is required"),
    last_name: Yup.string()
      .trim()
      .required("Last name is required"),
    email: Yup.string()
      .trim()
      .email("Please enter a valid email address")
      .required("Email address is required"),
    password: isEditMode
      ? Yup.string().optional()
      : Yup.string()
        .trim()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(/[@$!%*?&#]/, "Password must contain at least one special character (@$!%*?&#)"),
    shop_name: Yup.string()
      .trim()
      .required("Store name is required"),
    shop_slug: Yup.string()
      .trim()
      .required("Store slug is required"),
    commission_type: Yup.string()
      .required("Commission type is required"),
    commission: Yup.number()
      .typeError("Commission rate must be a number")
      .min(0, "Commission rate cannot be negative")
      .test(
        "max-if-percentage",
        "Commission rate cannot exceed 100%",
        function (val) {
          const { commission_type } = this.parent;
          if (commission_type === "percentage" && val > 100) {
            return false;
          }
          return true;
        }
      )
      .required("Commission rate is required"),
    phone: Yup.string()
      .optional()
      .test("is-digits", "Phone number must contain only digits", (val) => !val || /^[0-9]+$/.test(val))
      .test("is-valid-length", "Phone number must be between 10 and 15 digits", (val) => !val || (val.length >= 10 && val.length <= 15)),
    country_code: Yup.string()
      .optional()
      .test("is-country-code", "Country code must start with + followed by digits", (val) => !val || /^\+?[0-9]{1,4}$/.test(val)),
    profile_picture: Yup.string().optional(),
    vendor_logo: Yup.string().optional(),
    vendor_banner: Yup.string().optional(),
    vendor_tagline: Yup.string().optional(),
    vendor_address: Yup.string().optional(),
    social_links: Yup.object().shape({
      twitter: Yup.string().optional(),
      facebook: Yup.string().optional(),
      instagram: Yup.string().optional(),
      linkedin: Yup.string().optional(),
    }),
  });
};

export const TAB_FIELDS = {
  general: ["first_name", "last_name", "email", "password", "shop_name", "shop_slug", "phone", "country_code", "vendor_tagline"],
  commission: ["commission_type", "commission"],
  social: [],
};

export const validateTabFields = async (tab, formikValues, isEditMode = false) => {
  const schema = getVendorValidationSchema(isEditMode);
  const fieldsToValidate = TAB_FIELDS[tab] || [];
  const errors = {};

  for (const field of fieldsToValidate) {
    if (field === "password" && isEditMode) continue;
    try {
      await schema.validateAt(field, formikValues);
    } catch (err) {
      if (err.path && err.message) {
        errors[err.path] = err.message;
      }
    }
  }

  return errors;
};

export const getFirstTabWithError = (errors) => {
  for (const [tab, fields] of Object.entries(TAB_FIELDS)) {
    if (fields.some((field) => errors[field])) {
      return tab;
    }
  }
  return null;
};
